import { Button } from '@/components/ui/button';
import { WifiIcon } from '@heroicons/react/24/solid';
import { DocumentIcon, HomeIcon } from '@heroicons/react/24/outline';
import { useGlobalStore } from '@/stores/store';
import { apiMutationKeys } from '@/services/apis/apiMutationKeys';
import { getQuoteSummary } from '@/services/apis/getQuoteSummary';
import { useMutation } from '@tanstack/react-query';
import { createMobileOfferPayload } from '@/utils/quote-summary';
import { useShallow } from 'zustand/react/shallow';
import { getGlobalStore } from '@/utils/store';

const BroadbandCartItem = () => {
  const {
    setLatestNewDevelopmentCharge,
    setLatestBroadbandOffer,
    setIsShoppingCartOpen,
  } = getGlobalStore();

  const {
    latestBroadbandOffer,
    latestMobileOffer,
    latestNewDevelopmentCharge,
  } = useGlobalStore(
    useShallow((store) => ({
      latestBroadbandOffer: store.shoppingCartStore.latestBroadbandOffer,
      latestMobileOffer: store.shoppingCartStore.latestMobileOffer,
      latestNewDevelopmentCharge:
        store.shoppingCartStore.latestNewDevelopmentCharge,
    }))
  );

  const { mutate, isPending } = useMutation({
    mutationFn: getQuoteSummary,
    mutationKey: [...apiMutationKeys.getQuoteSummary],
  });
  const handleRemove = () => {
    //NOTE: If we don't have a mobile offer, we don't need to call the mutation. We just need to remove the item(GlobalStore) + NDC + close the modal
    if (!latestMobileOffer) {
      setLatestBroadbandOffer(null);
      setLatestNewDevelopmentCharge(null);
      setIsShoppingCartOpen(false);
      return;
    }
    const payload = createMobileOfferPayload(latestMobileOffer.id);
    mutate(
      {
        quoteSummaryRequest: {
          ...payload,
        },
      },
      {
        onSuccess: () => {
          setLatestBroadbandOffer(null);
          setLatestNewDevelopmentCharge(null);
          //NOTE: We don't need to close the modal, because there are still mobile offers in the cart
        },
      }
    );
  };

  if (!latestBroadbandOffer) {
    return null;
  }

  const price = latestBroadbandOffer.prices[0].amount;

  return (
    <div className="flex flex-col gap-3 md:gap-4">
      {latestNewDevelopmentCharge ? (
        <>
          <div className="flex justify-between items-center text-xs md:text-sm lg:text-base font-nunito700 text-grey-900">
            <div>Total once off cost</div>
            <div>$ {latestNewDevelopmentCharge.prices[0].amount}</div>
          </div>
          <div className="flex justify-between items-center">
            <div className="flex gap-2 items-center">
              <HomeIcon className="size-5 lg:size-6" />
              <div className="text-xs md:text-sm lg:text-base text-grey-900">
                New development charge
              </div>
            </div>
            <div className="text-xs md:text-sm lg:text-base text-grey-600">
              $ {latestNewDevelopmentCharge.prices[0].amount}
            </div>
          </div>
        </>
      ) : null}
      <div className="flex justify-between items-start">
        <div className="font-nunito700 text-grey-900 text-xs md:text-sm lg:text-base">
          Total monthly cost for <br /> internet services
        </div>
        <div className="">
          <div className="text-right font-nunito700 text-grey-900 text-xs md:text-sm lg:text-base">
            ${price}
          </div>
        </div>
      </div>
      <div className="flex justify-between items-center">
        <div className="flex flex-[0.58] gap-2 items-center">
          <WifiIcon className="size-5 lg:size-6" />
          <div className="text-xs md:text-sm text-grey-900">
            {latestBroadbandOffer.content.heading}
          </div>
        </div>
      </div>
      <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
          <DocumentIcon className="size-5 lg:size-6" />
          <div className="text-xs md:text-sm text-grey-900">
            Contract length
          </div>
        </div>
        <div className="text-xs text-grey-600">
          {latestBroadbandOffer.contractMonths === 0 ? 'No lock-in' : 'Lock-in'}
        </div>
      </div>
      <div className="flex justify-end">
        <Button
          variant="linkDanger"
          size="extraSmall"
          className="pr-0 relative text-xs md:text-sm"
          loading={isPending}
          onClick={handleRemove}
        >
          Remove
        </Button>
      </div>
    </div>
  );
};

export { BroadbandCartItem };
